import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import ReactCountryFlag from 'react-country-flag';

const Header = ({ language, onToggleLanguage }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const texts = {
    en: {
      logo: 'MobileHub4u',
      nav: ['Features', 'How it works', 'Benefits'],
      cta: 'Get started',
    },
    de: {
      logo: 'MobileHub4u',
      nav: ['Funktionen', 'So funktioniert’s', 'Vorteile'],
      cta: 'Jetzt starten',
    },
  };

  const t = texts[language];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-950/90 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <a href="#top" className="text-xl font-heading font-bold text-brand-400 tracking-tight">
            {t.logo}
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {t.nav.map((item, i) => (
              <a
                key={i}
                href={`#section-${i + 2}`}
                className="text-slate-300 hover:text-brand-400 transition-colors text-sm font-medium"
              >
                {item}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={onToggleLanguage}
              className="flex items-center justify-center p-2 rounded-lg bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white transition-colors"
              aria-label={language === 'en' ? 'Switch to German' : 'Switch to English'}
              title={language === 'en' ? 'Deutsch' : 'English'}
            >
              <ReactCountryFlag
                countryCode={language === 'en' ? 'CH' : 'GB'}
                svg
                style={{ width: '1.5rem', height: '1.125rem' }}
              />
            </button>
            <a
              href="/s"
              className="hidden sm:inline-flex items-center px-5 py-2.5 rounded-lg bg-brand-500 text-white font-medium text-sm hover:bg-brand-600 transition-colors"
            >
              {t.cta}
            </a>
            <button
              className="md:hidden p-2 text-slate-400 hover:text-white"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Menu"
            >
              {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden py-4 border-t border-slate-800">
            <nav className="flex flex-col gap-2">
              {t.nav.map((item, i) => (
                <a
                  key={i}
                  href={`#section-${i + 2}`}
                  className="text-slate-300 hover:text-brand-400 py-2"
                  onClick={() => setMobileOpen(false)}
                >
                  {item}
                </a>
              ))}
              <a href="/s" className="text-brand-400 font-medium py-2">
                {t.cta}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
